import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppTheme } from "../../context/ThemeContext";
import { getOssBridge, isNativeOssApp, isNativeOssTablet, nativeOssPlatform } from "../../lib/oss/bridge";

const BAR_LIGHT = "#F3F7F8";
const BAR_DARK = "#121816";

/** Collega login e area OSS al wrapper nativo (pronto, tema, tasto indietro, classe tablet). */
export function useOssNativeShell() {
  const location = useLocation();
  const navigate = useNavigate();
  const { effectiveTheme } = useAppTheme();
  const native = isNativeOssApp();

  useEffect(() => {
    if (!native) return undefined;
    const root = document.documentElement;
    root.classList.add("oss-native");
    if (isNativeOssTablet()) root.classList.add("oss-native-tablet");
    return () => {
      root.classList.remove("oss-native", "oss-native-tablet");
    };
  }, [native]);

  useEffect(() => {
    const bridge = getOssBridge();
    if (!bridge || typeof bridge.setTheme !== "function") return;
    const color = effectiveTheme === "dark" ? BAR_DARK : BAR_LIGHT;
    bridge.setTheme(effectiveTheme, color);
  }, [effectiveTheme]);

  useEffect(() => {
    if (!native) return undefined;
    const atRoot = location.pathname === "/oss" || location.pathname === "/oss-login";
    window.OssWeb = {
      platform: nativeOssPlatform(),
      tablet: isNativeOssTablet(),
      onBack: () => {
        if (atRoot) return false;
        navigate(-1);
        return true;
      },
    };
    return () => {
      delete window.OssWeb;
    };
  }, [location.pathname, navigate, native]);

  useEffect(() => {
    const bridge = getOssBridge();
    if (bridge && typeof bridge.ready === "function") bridge.ready();
  }, [location.pathname]);
}
